export var handleKeyPressEnter = function handleKeyPressEnter(func) {
  return function (event) {
    if (event.key === 'Enter') {
      func(event);
    }
  };
};